// extracted by mini-css-extract-plugin
module.exports = {"iframe":"_2uTQI"};